import React from 'react';

import { AppErrorBoundary } from './AppErrorBoundary.component';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  View?: React.ComponentType<{ error?: Error }>;
}

interface ErrorBoundaryState {
  hasError: boolean;
  componentStack: string;
  error?: Error;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      componentStack: '',
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    this.setState({ error });
  }

  render() {
    const { hasError, error } = this.state;
    const View = this.props.View || AppErrorBoundary;

    if (hasError) {
      return <View error={error} />;
    }

    return this.props.children;
  }
}
